import React, { useState, useEffect, useRef } from 'react';

import {
    Button, Cards, Checkbox, Container, ExpandableSection, FormField,
    Header, Input, Modal, SegmentedControl, Select, SpaceBetween
} from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { getParameter } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { LoadScript, GoogleMap, Marker, Circle } from '@react-google-maps/api';


interface Status {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface AccessMode {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface AccessType {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface GuestType {
    label: string;
    value: string;
    description?: string;
    iconName?: string;
}

interface sectorOption {
    value: string;
    description: string;
}

interface useOnlyOneOption {
    value: string;
    label: string;
    useOnlyOne: number;
}

interface guestTypeOption {
    value: string;
    label: string;
}


const guestTypes: guestTypeOption[] = [
    { value: "APP", label: "Aplicación" },
    { value: "READ.QR", label: "Leyendo código QR" },
    { value: "QR.CODE", label: "Mostrando código QR" },
]
const useOnlyOnes: useOnlyOneOption[] = [
    { value: "0", label: "Ilimitado", useOnlyOne: 0 },
    { value: "1", label: "1 sola vez", useOnlyOne: 1 },
    { value: "2", label: "2 veces", useOnlyOne: 2 },
    { value: "3", label: "3 veces", useOnlyOne: 3 },
    { value: "4", label: "4 veces", useOnlyOne: 4 },
    { value: "5", label: "5 veces", useOnlyOne: 5 },
]
const libraries = ['geometry'] as const;
export const ConfigAccessEditPage = () => {

    /*    
    import { FaBeer } from 'react-icons/fa';      // Font Awesome
    const BeerIcon = FaBeer as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    const QrCodeScanner = MdOutlineQrCodeScanner as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
    */

    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState(); const { menu, setMenu } = useGlobalState();
    const [loadingMain, setLoadingMain] = useState(false);
    const [isMapOpen, setIsMApOpen] = useState(false);
    const [init, setInit] = useState(false);
    const [mapUrl, setMapUrl] = useState('');
    const [acceso, setAcceso] = useState('');
    const [isActive, setIsActive] = useState(0);
    const [isMantAcceso, setIsMantAcceso] = useState(0);
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [access, setAccess] = useState<any>();
    const [position, setPosition] = useState({ lat: 0, lng: 0 });
    const [status, setStatus] = useState<string>('1');
    const [accessMode, setAccessMode] = useState<string>('');
    const [accessType, setAccessType] = useState<string>('');
    const [idSector, setIdSector] = useState<string>('');
    const [allowDistanceOpenCheck, setAllowDistanceOpenCheck] = useState(false);
    const [allowDistanceOpen, setAllowDistanceOpen] = useState(0); // Default radius in meters
    //const [selectedModes, setSelectedModes] = useState<AccessMode[]>([]);
    const [selectedAccessTypes, setSelectedAccessTypes] = useState<AccessType[]>([]);
    const [selectedAccessModes, setSelectedAccessModes] = useState<AccessMode[]>([]);
    const [selectedGuestTypes, setSelectedGuestTypes] = useState<GuestType[]>([]);
    const [sectors, setSectors] = useState<sectorOption[]>([]);
    const [selectedSector, setSelectedSector] = useState<sectorOption | null>(null);
    const mapRef = useRef<google.maps.Map | null>(null);

    const [manualOpenEnable, setManualOpenEnable] = useState(0);
    const [canHandleGuests, setCanHandleGuests] = useState(0);
    const [canHandleUsers, setCanHandleUsers] = useState(0);
    const [canHandleVisits, setCanHandleVisits] = useState(0);
    const [useOnlyOne, setUseOnlyOne] = useState(0);
    const [relay, setRelay] = useState(0);
    const [guestType, setGuestType] = useState("APP");
    //const mapRef = useRef(null);
    const { setLoading } = useGlobalState();

    // Example input string



    const handleStatusChange = (event: { detail: { value: string } }) => {
        console.log(event.detail.value);
        //console.log('Selected Status Value:', event.detail.value);
    };
    const statuses: Status[] = [
        { label: 'Activo', value: '1', description: 'El dispositivo se encuentra habilitado para operar normalmente', iconName: 'status-positive', },
        { label: 'Mantenimiento', value: '0', description: 'El dispositivo solo puede ser operado por un administrador', iconName: 'status-warning', },
        { label: 'Desactivado', value: '-1', description: 'El dispositivo no permite efectuar aperturas', iconName: 'status-negative', },
    ];
    const accessModes: AccessMode[] = [
        { label: "APP", description: "Apertura directa via App (Requiere conectividad de usuario", value: "APP" },
        { label: "BLE", description: "Apertura utilizando comunicación Bluetooth BLE", value: "BLE" },
        { label: "Lectura QR", description: "Usuario lee código QR en acceso", value: "READ.QR" },
        { label: "Mostrar QR", description: "Usuario despliega código QR a fiscalizador o lector QR", value: "SHOW.QR" },
        { label: "Matrícula", description: "Utilización de cámara LPR para reconocimiento de placa patente", value: "LPR" },
    ]
    const accessTypes: AccessType[] = [
        { label: "Aplicación", description: "1Apertura directa via App (Requiere conectividad de usuario", value: "HTTP" },
        { label: "Lectura QR", description: "1Usuario escanea código QR en acceso", value: "QR.CODE" },
        { label: "Mostrar QR", description: "1Usuario despliega código QR para fiscalización", value: "SHOW.QR" },
        { label: "Bluetooth BLE", description: "1Apertura utilizando comunicación Bluetooth BLE", value: "BLE" },
    ]
    useEffect(() => {
        const selectedValues = accessMode.split(',');
        const matchedModes = accessModes.filter(mode => selectedValues.includes(mode.value));
        setSelectedAccessModes(matchedModes);
    }, [accessMode]);
    useEffect(() => {
        const selectedValues = accessType.split(',');
        const matchedModes = accessTypes.filter(mode => selectedValues.includes(mode.value));
        setSelectedAccessTypes(matchedModes);
    }, [accessType]);

    const id = getParameter(window.location.hash, 'id');

    useEffect(() => {
        /*
        if (allowDistanceOpen < 10 && allowDistanceOpen > 0) {
            setAllowDistanceOpen(10);
            window.google?.maps?.geometry?.spherical
        } else {*/
        function fitMapToBounds() {
            if (!mapRef.current || !position) return;
            if (mapRef.current && allowDistanceOpen > 0) {
                let allowDistanceOpen2 = allowDistanceOpen;
                const bounds = new window.google.maps.LatLngBounds();
                const center = new window.google.maps.LatLng(position.lat, position.lng);

                // Add two points: one north, one south of the center at the radius distance
                if (window.google?.maps?.geometry?.spherical) {
                    const north = google.maps.geometry.spherical.computeOffset(center, allowDistanceOpen, 0);
                    const south = google.maps.geometry.spherical.computeOffset(center, allowDistanceOpen, 180);
                    const east = google.maps.geometry.spherical.computeOffset(center, allowDistanceOpen, 90);
                    const west = google.maps.geometry.spherical.computeOffset(center, allowDistanceOpen, 270);

                    bounds.extend(north);
                    bounds.extend(south);
                    bounds.extend(east);
                    bounds.extend(west);
                }
                mapRef.current.fitBounds(bounds);
            }
        }
        setTimeout(() => {
            fitMapToBounds();
        }, 0);
        //}

    }, [allowDistanceOpen]);
    const handleBtnSave = async () => {

        setLoading(true)
        const accessModes = selectedAccessModes.map(item => item.value).join(',');
        console.log(accessType)
        let body = {
            isMantAcceso: isMantAcceso,
            isActive: isActive,
            allowDistanceOpen: allowDistanceOpenCheck ? allowDistanceOpen : -1,
            idAcceso: parseInt(id),
            idSector: parseInt(idSector),
            accessModes: accessModes,
            accessType: accessType,
            manualOpenEnable: manualOpenEnable,
            canHandleGuests: canHandleGuests,
            canHandleUsers: canHandleUsers,
            canHandleVisits: canHandleVisits,
            useOnlyOne: canHandleGuests === 1 ? useOnlyOne : 1,
            guestType: canHandleGuests === 1 ? guestType : "",
        }
        console.log(body)
        try {

            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/accesses/set',
                    'JWT': JWT,

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            window.location.hash = `#config/accesses`;
        } catch (error) {
            console.error('Error fetching accesses:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleRefresh = async () => {
        //
        console.log("handleRefresh")
        try {

            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/properties/accesses/get',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idAcceso: id,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            storeAdmin(data);
            data.access.status = (data.access.isActive == 1) ? "1" : "-1"
            if (data.access.status != "0" && data.access.isMantAcceso == "1") data.access.status = "0"
            setAccess(data.access)
            data.access.status = data.access.status.toString()

            setAcceso(data.access.acceso);
            setAccessMode(data.access.accessModes)
            setAccessType(data.access.accessType)
            setIdSector(data.access.idSector)
            setStatus(data.access.status)
            setIsMantAcceso(data.access.isMantAcceso)
            setIsActive(data.access.isActive)
            if (data.access.allowDistanceOpen > 0) {
                setAllowDistanceOpen(data.access.allowDistanceOpen)
            } else {
                setAllowDistanceOpen(0)
                console.log("ELSE")
            }
            setAllowDistanceOpenCheck(data.access.allowDistanceOpen >= 0)
            setManualOpenEnable(data.access.manualOpenEnable || 0);
            setCanHandleGuests(data.access.canHandleGuests || 0);
            setCanHandleUsers(data.access.canHandleUsers || 0);
            setCanHandleVisits(data.access.canHandleVisits || 0);
            setUseOnlyOne(data.access.useOnlyOne || 0);
            setRelay(data.access.relay || 0);
            setGuestType(data.access.guestType || "");
            //if (data.access.allowDistanceOpen == -1) setAllowDistanceOpen(0)
            const mapped: sectorOption[] = data.sectors.map((item: { sector: string; idSector: number }) => ({
                description: (item.sector.toString() === "*") ? "General" : item.sector,
                value: item.idSector.toString(),
            }));
            try {

                const center = new window.google.maps.LatLng(0, 0);

                // Add two points: one north, one south of the center at the radius distance
                if (window.google?.maps?.geometry?.spherical) {
                    const north = google.maps.geometry.spherical.computeOffset(center, allowDistanceOpen, 0);
                }
            } catch (error) {
                console.log(error)
            }
            //setAccess(data.access);
            setSectors(mapped);

        } catch (error) {
            console.error('Error fetching accesses:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        //setLoading(true);
        //handleRefresh();
    }, [status]);


    useEffect(() => {
        if (access?.latAcceso && access?.lonAcceso) {
            setPosition({ lat: access.latAcceso, lng: access.lonAcceso });
            setTimeout(function () {
                //setAllowDistanceOpen(access.allowDistanceOpen);
            }, 200)
        }
    }, [access]);
    //setTimeout(function(){handleRefresh()},0)
    // Auto adjust zoom based on radius  

    useEffect(() => {
        handleRefresh();
    }, []);
    const mapRef2 = useRef(null);
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Configuración', href: '#config/default' },
                        { text: 'Accesos', href: '#config/accesses' },
                        { text: 'Configurar', href: '#config/access.edit' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Container
                        header={<Header>Configuración de acceso {acceso}</Header>}
                        footer={
                            <Box textAlign='right'>
                                <Button variant='link' href='#config/accesses'>
                                    Cancelar
                                </Button>
                                <Button variant='primary' onClick={() => handleBtnSave()}>
                                    Guardar cambios
                                </Button>
                            </Box>
                        }
                    >
                        {/* Add content here if needed */}
                        <>
                            <SpaceBetween direction='vertical' size='xs'>

                                <LoadScript googleMapsApiKey="AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc">
                                    <GoogleMap
                                        mapContainerStyle={{ width: '100%', height: '300px' }}
                                        center={position}
                                        zoom={13}
                                        onLoad={(map) => {
                                            mapRef.current = map;
                                        }}
                                        options={{
                                            disableDefaultUI: true,
                                            zoomControl: true,
                                            streetViewControl: false,
                                            mapTypeControl: true,
                                            fullscreenControl: false,
                                            draggable: false,
                                            scrollwheel: false,
                                            disableDoubleClickZoom: true
                                            //gestureHandling: 'none',
                                        }}
                                    >

                                        <Marker position={position}></Marker>
                                        {allowDistanceOpen > 0 && (
                                            <Circle
                                                center={position}
                                                radius={allowDistanceOpen} // Radius in meters
                                                options={{
                                                    strokeColor: '#FF0000',      // Red border color
                                                    strokeOpacity: 0.8,         // Border opacity
                                                    strokeWeight: 2,            // Border thickness
                                                    fillColor: '#FF0000',        // Red fill color
                                                    fillOpacity: 0.35,          // Fill opacity
                                                }}
                                            />
                                        )}
                                    </GoogleMap>
                                </LoadScript>
                                <SpaceBetween direction='horizontal' size='xs'>
                                </SpaceBetween>

                                <FormField
                                    label="Sector"
                                >
                                    <Select
                                        options={sectors.map(s => ({ label: s.description, value: s.value }))}
                                        selectedOption={
                                            sectors
                                                .map(s => ({ label: s.description, value: s.value }))
                                                .find(opt => opt.value === idSector.toString()) || null
                                        }
                                        onChange={({ detail }) => {
                                            const selected = sectors.find(s => s.value === detail.selectedOption.value);
                                            if (selected) {
                                                setSelectedSector(selected);
                                                setIdSector((selected.value));
                                            }
                                        }}
                                    />
                                </FormField>
                                {relay !== 0 && (
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <div style={{ width: '200px' }}>
                                            <FormField
                                                label={
                                                    <Checkbox
                                                        checked={allowDistanceOpenCheck}
                                                        onChange={({ detail }) => setAllowDistanceOpenCheck(detail.checked)}
                                                    >Restricción de distancia</Checkbox>}
                                                constraintText={"Distancia mínima a la cual se le permite la apertura al usuario"}>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>

                                                    <Input
                                                        value={allowDistanceOpen.toString()}
                                                        onChange={({ detail }) => {
                                                            if (Number(detail.value) >= 0)
                                                                setAllowDistanceOpen(Number(detail.value))
                                                        }}
                                                        type="number"
                                                        step={10}
                                                        placeholder="Distancia de apertura"
                                                        disabled={!allowDistanceOpenCheck}
                                                    />
                                                </div>
                                            </FormField>
                                        </div>
                                        <div style={{ flexGrow: 1 }}>

                                            <FormField
                                                label="Estado del acceso"
                                            >
                                                <SegmentedControl
                                                    selectedId={status}
                                                    onChange={({ detail }) => {
                                                        setStatus(detail.selectedId)
                                                        if (detail.selectedId === '0') {
                                                            setIsMantAcceso(1)
                                                        } else {
                                                            setIsMantAcceso(0)
                                                            if (detail.selectedId == "-1")
                                                                setIsActive(0)
                                                            else
                                                                setIsActive(1)
                                                        }
                                                    }
                                                    }
                                                    label="Default segmented control"
                                                    options={[
                                                        { text: "Activo", id: "1" },
                                                        { text: "Inactivo", id: "-1" },
                                                        { text: "Mantenimiento", id: "0" }
                                                    ]}
                                                />
                                            </FormField>
                                        </div>
                                    </div>
                                )}
                                {relay !== 0 && (
                                <FormField
                                    label="Tipo de apertura primaria"
                                >
                                    <SegmentedControl

                                        selectedId={accessType}
                                        onChange={({ detail }) => {
                                            setAccessType(detail.selectedId)
                                        }}
                                        label="Default segmented control"
                                        /*
                                        
                                                { label: "Aplicación", description: "1Apertura directa via App (Requiere conectividad de usuario", value: "HTTP" },
                                                { label: "Lectura QR", description: "1Usuario escanea código QR en acceso", value: "QR.CODE" },
                                                { label: "Mostrar QR", description: "1Usuario despliega código QR para fiscalización", value: "SHOW.QR" },
                                                { label: "Bluetooth BLE", description: "1Apertura utilizando comunicación Bluetooth BLE", value: "BLE" },
                                        */
                                        options={[
                                            { id: "HTTP", text: "Aplicación" },
                                            { id: "QR.CODE", text: "Lectura QR" },
                                            { id: "SHOW.QR", text: "Mostrar QR" },
                                            { id: "BLE", text: "Bluetooth BLE" }
                                        ]}

                                    />
                                </FormField>
                                )}

                                {relay !== 0 && (
                                <ExpandableSection headerText="Opciones de apertura secundaria" defaultExpanded={false}>
                                    <Cards
                                        cardDefinition={{
                                            header: item => (
                                                `${item.label}`
                                            ),
                                            sections: [
                                                {
                                                    id: "description",
                                                    content: item => item.description
                                                },
                                            ]
                                        }}
                                        cardsPerRow={[
                                            { cards: 1 },
                                            { minWidth: 500, cards: 3 }
                                        ]}
                                        items={accessModes}
                                        selectionType="multi"
                                        trackBy="value"  // ✅ Use correct unique key
                                        selectedItems={selectedAccessModes}
                                        onSelectionChange={({ detail }) => {
                                            setSelectedAccessModes(detail.selectedItems);
                                        }}
                                        entireCardClickable
                                    />
                                </ExpandableSection>
                                )}

                                <ExpandableSection headerText="Otras opciones" defaultExpanded={false}>
                                    <Checkbox
                                        checked={manualOpenEnable === 1}
                                        disabled={relay === 0}
                                        onChange={({ detail }) => setManualOpenEnable(detail.checked ? 1 : 0)}

                                        description="Permitir realizar aperturas desde la consola de administración"
                                    >Apertura manual {relay === 0 ? "*Virtual" : ""}</Checkbox>

                                    <Checkbox
                                        checked={canHandleUsers === 1}
                                        onChange={({ detail }) => setCanHandleUsers(detail.checked ? 1 : 0)}

                                        description="Usuarios pueden agregar este acceso desde la App de LlaveMovil"
                                    >Enrolamiento usuarios {relay === 0 ? "*Virtual" : ""}</Checkbox>

                                    <Checkbox
                                        checked={canHandleVisits === 1}
                                        onChange={({ detail }) => setCanHandleVisits(detail.checked ? 1 : 0)}

                                        description="Acceso puede ser utilizado por visitas/delivery/correspondencia"
                                    >Visitas</Checkbox>

                                    <Checkbox
                                        checked={canHandleGuests === 1}
                                        onChange={({ detail }) => setCanHandleGuests(detail.checked ? 1 : 0)}

                                        description="Acceso puede ser utilizado para gestionar invitaciones por los usuarios"
                                    >Invitados {guestType}</Checkbox>
                                    {canHandleGuests === 1 && (
                                        <SpaceBetween direction='horizontal' size='xs'>
                                            <Select
                                                selectedOption={guestTypes.find(s => s.value === guestType) || null}
                                                onChange={({ detail }) => {
                                                    setGuestType(detail.selectedOption.value || 'APP');
                                                }}
                                                options={guestTypes.map(s => ({ label: s.label, value: s.value }))}

                                            />

                                            <Select
                                                selectedOption={useOnlyOnes.find(s => s.useOnlyOne === useOnlyOne) || null}
                                                onChange={({ detail }) => {
                                                    console.log(detail.selectedOption.value)
                                                    setUseOnlyOne(Number(detail.selectedOption.value));
                                                }}
                                                options={useOnlyOnes}
                                                placeholder="Usos"
                                            />
                                        </SpaceBetween>
                                    )}

                                </ExpandableSection>

                            </SpaceBetween>
                        </>
                    </Container>

                    <Modal
                        visible={isMapOpen}
                        onDismiss={() => setIsMApOpen(false)}
                        header="Ubicación"
                        size="large"
                    >
                    </Modal>
                </>
            }
        />
    );
};
